import { render, staticRenderFns } from "./VerifyDoctorModal.vue?vue&type=template&id=9b47a8f8&"
import script from "./VerifyDoctorModal.vue?vue&type=script&lang=js&"
export * from "./VerifyDoctorModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports